export enum SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}
